<template>
  <div v-if="props.idEmpresaInmobiliaria" class="container-fluid container-fluid px-4 rounded-4 contenedor-principal">
    <navegar-atras :ruta="ruta"></navegar-atras>
    <empresa-inmobiliaria-info :id-empresa-inmobiliaria="idEmpresaInmobiliaria"></empresa-inmobiliaria-info>
    <empresa-inmobiliaria-gestion-tab :id-empresa-inmobiliaria="props.idEmpresaInmobiliaria" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import NavegarAtras from "@/components/NavegarAtras.vue";
import EmpresaInmobiliariaInfo from "@/components/empresas-agentes/EmpresaInmobiliariaInfo.vue";
import EmpresaInmobiliariaGestionTab from "@/components/empresas-agentes/EmpresaInmobiliariaGestionTab.vue";

const props = defineProps({
  idEmpresaInmobiliaria: String
});

const ruta = computed(() => `/empresas-agentes/inmobiliarias`);
</script>